module.exports = __webpack_public_path__ + "static/media/Human_ZG5121_360.7c630077.jpeg";